/* KOL-slider. Scroll-snap doet het vegen; dit script doet alleen de pijltjes
   en de bolletjes, en houdt ze in sync met waar je bent.

   Geen library: het is een horizontale scroller, daar is scrollTo genoeg voor.
   Werkt ook zonder dit script, dan veeg je gewoon. */
(function () {
  function init(root) {
    var track = root.querySelector('.k-kol__track');
    var dotsWrap = root.querySelector('.k-kol__dots');
    var prev = root.querySelector('.k-kol__arrow--prev');
    var next = root.querySelector('.k-kol__arrow--next');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) {
      var controls = root.querySelector('.k-kol__controls');
      if (controls) controls.hidden = true;
      return;
    }

    // Bolletjes: eentje per kaart.
    var dots = [];
    if (dotsWrap) {
      cards.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'k-kol__dot';
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () {
          scrollToCard(i);
        });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function currentIndex() {
      // Dichtstbijzijnde kaart bij de linkerrand van de track.
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (c, i) {
        var dist = Math.abs(c.offsetLeft - track.scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function scrollToCard(i) {
      var c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (c) track.scrollTo({ left: c.offsetLeft, behavior: 'smooth' });
    }

    function sync() {
      var i = currentIndex();
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
      });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToCard(currentIndex() - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollToCard(currentIndex() + 1);
      });
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          sync();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function boot() {
    document.querySelectorAll('.k-kol').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // De theme-editor hangt secties opnieuw in de DOM.
  document.addEventListener('shopify:section:load', boot);
})();
